import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Sparkles, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. Please log in.");
      setTimeout(() => nav("/login"), 800);
    } catch (err) { toast.error("Reset failed", { description: formatApiError(err) }); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white relative overflow-hidden flex items-center justify-center p-6" data-testid="reset-password-page">
      <div className="aurora" />
      <form onSubmit={submit} className="glass rounded-2xl p-8 w-full max-w-md relative overflow-hidden z-10">
        <div className="absolute -top-24 -right-24 w-56 h-56 rounded-full bg-gradient-to-br from-indigo-500/25 to-fuchsia-500/10 blur-3xl" />
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-indigo-500 to-fuchsia-500 flex items-center justify-center">
            <Sparkles className="w-4 h-4" />
          </div>
          <span className="font-display font-extrabold text-xl">SyncLine</span>
        </Link>
        <h2 className="font-display font-extrabold text-3xl mb-4">Set a new password</h2>

        {!params.get("token") && (
          <>
            <label className="block text-xs uppercase tracking-widest text-mute mb-1.5">Reset token</label>
            <input required value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token"
              className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2.5 mb-4 font-mono text-xs focus:border-indigo-400 focus:outline-none" />
          </>
        )}
        <label className="block text-xs uppercase tracking-widest text-mute mb-1.5">New password</label>
        <input required type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
          data-testid="reset-password" className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2.5 mb-4" />
        <label className="block text-xs uppercase tracking-widest text-mute mb-1.5">Confirm</label>
        <input required type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)}
          data-testid="reset-confirm" className="w-full bg-black/50 border border-white/10 rounded-md px-3 py-2.5 mb-5" />
        <button disabled={loading} data-testid="reset-submit"
          className="w-full bg-indigo-500 hover:bg-indigo-400 disabled:opacity-60 px-4 py-2.5 rounded-md font-medium flex items-center justify-center gap-2">
          {loading ? "Resetting…" : (<>Reset password <ArrowRight className="w-4 h-4" /></>)}
        </button>
      </form>
    </div>
  );
}
